

























import { Component, Vue } from 'vue-property-decorator';
import { SysModule } from '@/store/modules/sys';
import { AppModule } from '@/store/modules/app';
import WorkerUserList from '@/components/Users/WorkerUserList.vue'
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'


@Component({

	name: 'WorkerUsers',
  	components: { WorkerUserList, Alert }
})
export default class extends GiganautVue {

	created() {
		SysModule.getWorkerUsers();
  	}

  	get loading() {
		return SysModule.loading;
  	}
}
